import { ElSwitch } from 'element-plus'
import { computed, defineComponent, h } from 'vue'

export default defineComponent({
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const defaultValue = props?.context?.attrs?.attrs?.defaultVal ?? false

    const value = computed({
      get: () => props.context.value ?? defaultValue,
      set: (val) => props.context.node.input(val),
    })

    return () =>
      h(
        ElSwitch,
        Object.assign(props.context, props.context.attrs, {
          modelValue: value.value,
          'onUpdate:modelValue': (val) => (value.value = val),
        }),
      )
  },
})
